<template>
  <div>
    <b-modal
      modal-class="client-form-modal"
      body-class="bg-white p-0"
      footer-class="bg-extra-light-gray"
      v-model="editorShown"
      :title="''"
      @ok="saveUser"
      size="md-lg"
      centered
      no-close-on-backdrop
      header-bg-variant="primary"
      header-text-variant="white"
      header-class="bg-purple"
    >
      <template v-slot:modal-header>
        <div
          class="
            w-100
            d-flex
            flex-row
            justify-content-between
            align-items-center
          "
        >
          <h5 v-if="!providerId" class="modal-title">Add Provider</h5>
          <h5 v-else class="modal-title">Edit Provider</h5>
          <div class="d-flex align-items-center">
            <button
              type="button"
              aria-label="Close"
              class="close text-white"
              @click="$emit('onModify')"
            >
              ×
            </button>
          </div>
        </div>
      </template>

      <template v-slot:modal-footer>
        <div class="d-flex justify-content-end align-items-center w-100">
          <div class="text-center mt-1 mr-2">
            <b-button @click="$emit('onModify')" variant="secondary"
              >Close</b-button
            >
            <b-button class="ml-2" variant="info" @click="saveUser"
              >Save</b-button
            >
          </div>
        </div>
      </template>
      <b-row class="mx-3 mt-3">
        <b-col>
          <b-row class="mb-3">
            <b-col class="col-sm-8 col-md-8 col-lg-4">
              <b-form-group
                label="Select User"
                :state="formErrors.user.length == 0 ? null : false"
                :invalid-feedback="formErrors.user.join(', ')"
              >
                <template v-slot:label>
                  Select User <span class="text-danger">*</span>
                </template>
                <v-select
                  :disabled="this.providerId ? true : false"
                  v-model="user"
                  :options="usersFilters"
                ></v-select>
                <b-col>
                  <b-row align-h="start">
                    {{ user ? user.data.email : "" }}</b-row
                  >
                  <b-row align-h="start">{{
                    user ? user.data.phone : ""
                  }}</b-row>
                  <b-row align-h="start">{{
                    user ? "Role " + user.data.role.name : ""
                  }}</b-row>
                </b-col>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button
            size="lg"
            v-b-toggle.collapse-1
            class="mb-3 font-weight-bold col-12 d-flex justify-content-between"
            variant="light"
            >Provider Information<span class="when-opened"
              ><i class="fa fa-chevron-up" aria-hidden="true"></i></span
            ><span class="when-closed"
              ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
          ></b-button>
          <b-collapse id="collapse-1" visible>
            <b-row>
              <b-col cols="4">
                <b-form-group
                  label="Tax ID"
                  :state="formErrors.taxId.length == 0 ? null : false"
                  :invalid-feedback="formErrors.taxId.join(', ')"
                >
                  <template v-slot:label>
                    Tax ID <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model="form.taxId"
                    trim
                    maxLength="30"
                    :state="formErrors.taxId.length == 0 ? null : false"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group
                  label="NPI"
                  :state="formErrors.npi.length == 0 ? null : false"
                  :invalid-feedback="formErrors.npi.join(', ')"
                >
                  <template v-slot:label>
                    NPI <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    v-model="form.npi"
                    trim
                    maxLength="30"
                  ></b-form-input> </b-form-group
              ></b-col>
              <b-col cols="4">
                <b-form-group label="Taxonomy">
                  <template v-slot:label> Taxonomy </template>
                  <taxonomy-picker
                    v-model="taxonomy"
                  ></taxonomy-picker> </b-form-group
              ></b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <b-form-group label="Credentials">
                  <b-form-select
                    v-model="form.credentialId"
                    :options="credentials"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="DEA">
                  <b-form-input
                    v-model="form.dea"
                    trim
                    maxLength="30"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="License #">
                  <b-form-input
                    v-model="form.licenseNo"
                    trim
                    maxLength="255"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="col-sm-6 col-md-6 col-lg-4">
                <b-form-group label="UPIN">
                  <b-form-input
                    v-model="form.upin"
                    trim
                    maxLength="30"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col class="col-sm-6 col-md-6 col-lg-4">
                <b-form-group
                  label="Manager"
                  :state="formErrors.manager.length == 0 ? null : false"
                  :invalid-feedback="formErrors.manager.join(', ')"
                >
                  <v-select
                    v-model="manager"
                    :options="managersFiltersOptions"
                  ></v-select> </b-form-group
              ></b-col>
              <b-col class="col-sm-6 col-md-6 col-lg-4">
                <b-form-group label="Supervisor">
                  <v-select
                    v-model="supervisor"
                    :options="supervisorOptions"
                  ></v-select> </b-form-group
              ></b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col>
                <b-form-checkbox v-model="form.canSeeSuperviseesInfo">
                  Can see Supervisee information
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-collapse>

          <b-button
            size="lg"
            v-b-toggle.collapse-2
            class="mb-3 font-weight-bold col-12 d-flex justify-content-between"
            variant="light"
            >Address<span class="when-opened"
              ><i class="fa fa-chevron-up" aria-hidden="true"></i></span
            ><span class="when-closed"
              ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
          ></b-button>
          <b-collapse id="collapse-2" visible>
            <b-row>
              <b-col cols="6">
                <b-form-group label="Address Line 1">
                  <b-form-input
                    v-model="form.addressLine1"
                    trim
                    maxLength="255"
                  ></b-form-input> </b-form-group
              ></b-col>
              <b-col cols="6">
                <b-form-group label="Address Line 2">
                  <b-form-input
                    v-model="form.addressLine2"
                    trim
                    maxLength="255"
                  ></b-form-input> </b-form-group
              ></b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="4">
                <b-form-group label="State">
                  <v-select
                    v-model="state"
                    :options="states"
                  ></v-select> </b-form-group
              ></b-col>
              <b-col cols="4">
                <b-form-group label="City">
                  <b-form-input
                    v-model="form.city"
                    trim
                    maxLength="100"
                  ></b-form-input> </b-form-group
              ></b-col>
              <b-col cols="4">
                <b-form-group
                  label="Zipcode"
                  :state="formErrors.zipcode.length == 0 ? null : false"
                  :invalid-feedback="formErrors.zipcode.join(', ')"
                >
                  <b-form-input
                    v-model="form.zipcode"
                    trim
                    v-facade="'#####'"
                    :state="formErrors.zipcode.length == 0 ? null : false"
                  ></b-form-input> </b-form-group
              ></b-col>
            </b-row>
          </b-collapse>
          <b-button
            size="lg"
            v-b-toggle.collapse-7
            class="mb-3 font-weight-bold col-12 d-flex justify-content-between"
            variant="light"
            >Places of Service<span class="when-opened"
              ><i class="fa fa-chevron-up" aria-hidden="true"></i></span
            ><span class="when-closed"
              ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
          ></b-button>
          <b-collapse id="collapse-7" visible>
            <b-row>
              <b-col cols="12">
                <b-form-group label="" class="mt-4">
                  <div class="d-flex mb-2">
                    <b-link
                      :disabled="
                        placeOfServices.length == placesOfServiceOptions.length
                      "
                      href="#"
                      @click="allPlaceOfServiceChangeState"
                      >Assign all Places of Service</b-link
                    >
                  </div>
                  <multiple-select
                    :options="placesOfServiceOptions"
                    v-model="placeOfServices"
                    :listDraggable="false"
                    :maxHeight="'705px'"
                    :sortFn="(a, b) => a.data.name.localeCompare(b.data.name)"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-collapse>
          <b-button
            size="lg"
            v-b-toggle.collapse-3
            class="mb-3 font-weight-bold col-12 d-flex justify-content-between"
            variant="light"
            >Locations<span class="when-opened"
              ><i class="fa fa-chevron-up" aria-hidden="true"></i></span
            ><span class="when-closed"
              ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
          ></b-button>
          <b-collapse id="collapse-3" visible>
            <b-row class="mb-3">
              <b-col>
                <div>
                  <b-link
                    v-if="form.accessToLocations?.length != locations?.length"
                    href="#"
                    @click="hasAccessToLocations(true)"
                    >Select all Locations</b-link
                  >
                  <b-link
                    v-else
                    disabled
                    href="#"
                    @click="hasAccessToLocations(true)"
                    >Select all Locations</b-link
                  >
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                v-for="(chunk, chunkIndex) in chunks(locations, 2)"
                :key="chunkIndex"
                ><b-form-group v-for="location in chunk" :key="location.value">
                  <div class="d-flex">
                    <vue-toggles
                      :value="toggleLocations[location.value]"
                      @click="changeVueToggle(location)"
                      height="25"
                      width="40"
                      checkedBg="#34C759"
                      uncheckedBg="#FF6161"
                    />
                    <small class="ml-3">{{ location.text }}</small>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-show="formErrors.accessToLocations.length > 0">
              <b-col>
                <p style="margin-top:0.25rem;font-size:0.875em;color: #FF6161;">
                  {{ formErrors.accessToLocations.join(", ") }}
                </p>
              </b-col>
            </b-row>
          </b-collapse>
          <b-button
            size="lg"
            v-b-toggle.collapse-4
            class="mb-3 font-weight-bold col-12 d-flex justify-content-between"
            variant="light"
            >Services Provided<span class="when-opened"
              ><i class="fa fa-chevron-up" aria-hidden="true"></i></span
            ><span class="when-closed"
              ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
          ></b-button>
          <b-collapse id="collapse-4" visible>
            <b-row>
              <b-col cols="12">
                <b-form-group label="" class="mt-4">
                  <div class="d-flex mb-2">
                    <b-link
                      :disabled="servicesSelect.length == services.length"
                      href="#"
                      @click="allServicesChangeState"
                      >Assign all Services</b-link
                    >
                  </div>
                  <multiple-select
                    :options="services"
                    v-model="servicesSelect"
                    :listDraggable="false"
                    :maxHeight="'705px'"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-collapse>

          <b-button
            size="lg"
            v-b-toggle.collapse-5
            class="mb-3 font-weight-bold col-12 d-flex justify-content-between"
            variant="light"
            >Insurance Network<span class="when-opened"
              ><i class="fa fa-chevron-up" aria-hidden="true"></i></span
            ><span class="when-closed"
              ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
          ></b-button>
          <b-collapse id="collapse-5" visible>
            <b-row>
              <b-col cols="12">
                <b-form-group class="mt-4" label="">
                  <div class="d-flex mb-2">
                    <b-link
                      :disabled="
                        insuracesCompanies.length == insuracesCompany.length
                      "
                      href="#"
                      @click="allNetworkChangeState"
                      >Assign all Payers</b-link
                    >
                  </div>
                  <multiple-select
                    :options="insuracesCompany"
                    v-model="insuracesCompanies"
                    :listDraggable="false"
                    :maxHeight="'705px'"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-collapse>
          <b-button
            size="lg"
            v-b-toggle.collapse-6
            class="mb-3 font-weight-bold col-12 d-flex justify-content-between"
            variant="light"
            >Additional Configurations<span class="when-opened"
              ><i class="fa fa-chevron-up" aria-hidden="true"></i></span
            ><span class="when-closed"
              ><i class="fa fa-chevron-down" aria-hidden="true"></i></span
          ></b-button>
          <b-collapse id="collapse-6" visible>
            <b-row>
              <b-col cols="4">
                <b-form-group label="Practice Suite Physician Id">
                  <b-form-input
                    v-model="form.practiceSuitePhysician"
                    trim
                    maxLength="30"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="DoseSpot Physician Id">
                  <b-form-input
                    v-model="form.doseSpotId"
                    trim
                    maxLength="30"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="">
                  <b-form-checkbox v-model="form.hasPMPAccess">
                    Enable PMP Access
                  </b-form-checkbox></b-form-group
                >

                <b-form-group
                  v-if="form.hasPMPAccess"
                  label="PMP Role"
                  :state="formErrors.pmpRoles.length == 0 ? null : false"
                  :invalid-feedback="formErrors.pmpRoles.join(', ')"
                >
                  <template v-slot:label>
                    PMP Role <span class="text-danger">*</span>
                  </template>
                  <v-select
                    v-model="form.pmpRole"
                    :options="pmpRoles"
                  ></v-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-collapse>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  validateRequired,
  validateIsNumber,
  validateZipcode,
  validateLengthEqualThan
} from "../../helpers/validation";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import userServer from "../../server/user";
import insuranceCompanyServer from "../../server/insuranceCompany";
import serviceServer from "../../server/service";
import providersServer from "../../server/providers";
import TaxonomyPicker from "../controls/TaxonomyPicker";
import MultipleSelect from "../controls/MultipleSelect.vue";
import { chunks } from "../../helpers/general";
import supervisionServer from "../../server/supervision";
import systemSettingServer from "../../server/systemSetting";
export default {
  name: "ProvidersAddEditModal",
  components: {
    TaxonomyPicker,
    MultipleSelect
  },
  props: ["providerId"],
  data() {
    return {
      taxonomy: null,
      users: [],
      user: null,
      state: null,
      services: [],
      insuracesCompany: [],
      userId: "",
      servicesSelect: [],
      insuracesCompanies: [],
      managersOptions: [],
      supervisorOptions: [],
      managersFiltersOptions: [],
      usersFilters: [],
      manager: null,
      supervisor: null,
      toggleLocations: {},
      organization: null,
      placeOfServices: [],
      form: {
        dea: "",
        taxId: "",
        npi: "",
        upin: "",
        licenseNo: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        stateId: null,
        zipcode: "",
        hasPMPAccess: false,
        pmpRole: null,
        accessToLocations: [],
        roleId: null,
        credentialId: null,
        practiceSuitePhysician: null,
        doseSpotId: null,
        canSeeSuperviseesInfo: true
      },
      formErrors: {
        user: [],
        taxId: [],
        npi: [],
        pmpRoles: [],
        zipcode: [],
        accessToLocations: [],
        manager: []
      },
      pmpRoles: [
        {
          label: "Physician",
          value: "Physician"
        },
        {
          label: "Dentist",
          value: "Dentist"
        },
        {
          label: "Nurse Practioner",
          value: "NursePractioner"
        },
        {
          label: "Physicians Assistant",
          value: "PhysiciansAssistant"
        },
        {
          label: "Pharmacist",
          value: "Pharmacist"
        },
        {
          label: "Resident",
          value: "Resident"
        },
        {
          label: "Intern",
          value: "Intern"
        },
        {
          label: "Psychologist",
          value: "Psychologist"
        },
        {
          label: "Optometrist",
          value: "Optometrist"
        },
        {
          label: "Naturopathic Physician",
          value: "NaturopathicPhysician"
        }
      ]
    };
  },
  async mounted() {
    await this.getServices();
    await this.fetchProvider();
    await this.fetchUsers();
    await this.fetchPlacesOfService();
    this.fetchStates();
    this.fetchOrganization();
    this.fetchManagers();
    this.fetchLocations();
    this.getInsuranceCompanies();
    this.fetchCredentials();
    this.hasAccessToLocations();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "showError"]),
    ...mapActions("layout", ["fetchCredentials"]),
    ...mapActions("client", [
      "fetchStates",
      "fetchLocations",
      "fetchPlacesOfService"
    ]),
    allServicesChangeState() {
      this.services.forEach(s => {
        const exists = this.servicesSelect.find(x => x.value == s.value);
        if (!exists) {
          this.servicesSelect.push(s);
        }
      });
    },
    allPlaceOfServiceChangeState() {
      this.placesOfServiceOptions.forEach(pos => {
        const exists = this.placeOfServices.find(x => x.value == pos.value);
        if (!exists) {
          this.placeOfServices.push(pos);
        }
      });
    },
    allNetworkChangeState() {
      this.insuracesCompany.forEach(s => {
        const exists = this.insuracesCompanies.find(x => x.value == s.value);
        if (!exists) {
          this.insuracesCompanies.push(s);
        }
      });
    },
    chunks(values, chunkCount) {
      return chunks(values, chunkCount);
    },
    hasAccessToLocations(allLocations = false) {
      this.locations.forEach(location => {
        this.$set(
          this.toggleLocations,
          location.value,
          allLocations
            ? true
            : this.form.accessToLocations.some(l => l == location.value)
        );
      });
      if (allLocations) {
        this.form.accessToLocations = this.locations.map(l => l.value);
      }
    },
    changeVueToggle(location) {
      if (!this.toggleLocations[location.value]) {
        this.form.accessToLocations.push(location.value);
      } else if (this.form.accessToLocations.length >= 0) {
        this.form.accessToLocations = this.form.accessToLocations.filter(
          l => l != location.value
        );
      }
      this.$set(
        this.toggleLocations,
        location.value,
        !this.toggleLocations[location.value]
      );
    },
    async fetchProvider() {
      if (this.providerId) {
        let result = await userServer.get(this.providerId);
        let provider = result;
        (this.user = {
          value: provider.id,
          label: this.formatUser(provider),
          data: provider
        }),
          (this.taxonomy = provider.taxonomy
            ? {
                value: provider.taxonomy.id,
                label: provider.taxonomy.code
              }
            : null),
          (this.state = provider.state
            ? this.states.find(s => s.value == provider.state.id)
            : null),
          (this.manager = provider.manager
            ? this.managersFiltersOptions.find(
                m => m.value == provider.manager.id
              )
            : null),
          (this.form = {
            dea: provider.dea,
            taxId: provider.taxId,
            npi: provider.npi,
            upin: provider.upin,
            licenseNo: provider.licenseNo,
            addressLine1: provider.addressLine1,
            addressLine2: provider.addressLine2,
            city: provider.city,
            zipcode: provider.zipcode,
            hasPMPAccess: provider.hasPMPAccess,
            accessToLocations: provider.accessToLocations.map(l => l.id),
            credentialId: provider.credentialId,
            practiceSuitePhysician: provider.practiceSuitePhysician,
            doseSpotId: provider.doseSpotId,
            pmpRole: provider.pmpRole
              ? this.pmpRoles.find(pr => pr.value == provider.pmpRole)
              : null,
            canSeeSuperviseesInfo: provider.canSeeSuperviseesInfo
          });

        if (provider.services) {
          this.servicesSelect = this.services.filter(s =>
            provider.services.some(x => x.id === s.value)
          );
        }
        if (provider.insuracesCompanies) {
          this.insuracesCompanies = provider.insuracesCompanies.map(s => ({
            value: s.id,
            label: s.name,
            data: s
          }));
        }
        if (provider.placeOfServices) {
          this.placeOfServices = provider.placeOfServices
            .map(pos => ({
              value: pos.id,
              label: `${pos.code}-${pos.name}`,
              data: pos
            }))
            .sort((a, b) => {
              return a.data.name.localeCompare(b.data.name);
            });
        }
      }
    },
    async getServices() {
      const services = await serviceServer.query({
        type: "Service"
      });
      this.services = services.map(s => ({
        value: s.id,
        label: `${s.billingCodes[0] ? s.billingCodes[0].cptCode + " - " : ""} ${
          s.name
        }`,
        data: s
      }));
    },
    async fetchOrganization() {
      const organization = await systemSettingServer.get();
      this.organization = {
        value: organization.id,
        label: organization.organizationName,
        isOrganization: true,
        data: organization
      };
    },
    async getInsuranceCompanies() {
      const result = await insuranceCompanyServer.query({
        pageSize: 10000
      });
      this.insuracesCompany = result.records.map(r => ({
        value: r.id,
        label: r.name,
        data: r
      }));
    },
    async saveUser() {
      this.clearErrors();
      const result = this.validateSubmit();

      if (result) {
        const formData = {
          ...this.form,
          taxonomyId: this.taxonomy ? this.taxonomy.value : null,
          pmpRole: this.form.hasPMPAccess ? this.form.pmpRole.value : null,
          stateId: this.state ? this.state.value : null,
          servicesId: this.servicesSelect
            ? this.servicesSelect.map(i => i.value)
            : [],
          insuracesCompanyId: this.insuracesCompanies
            ? this.insuracesCompanies.map(i => i.value)
            : [],
          placeOfServicesId: this.placeOfServices
            ? this.placeOfServices.map(i => i.value)
            : [],
          roleId: this.user.data.role.id,
          managerId: this.manager ? this.manager.value : null,
          isSelectSupervisor: this.supervisor != null,
          supervisorId: this.supervisor
            ? this.supervisor?.isOrganization
              ? null
              : this.supervisor.value
            : null
        };
        await providersServer.updateProvider(this.user.value, formData);

        this.$emit("onModify");
      }
    },
    validateSubmit() {
      let withoutErrors = true;
      this.formErrors.accessToLocations = [];
      if (this.form.accessToLocations.length == 0) {
        this.formErrors.accessToLocations.push(
          "Must select at least 1 location"
        );
        withoutErrors = false;
      }
      this.formErrors.user = [];
      if (!validateRequired(this.user)) {
        this.formErrors.user.push("This field is required");
        withoutErrors = false;
      }
      this.formErrors.taxId = [];
      if (!validateRequired(this.form.taxId)) {
        this.formErrors.taxId.push("This field is required");
        withoutErrors = false;
      }
      this.formErrors.zipcode = [];
      if (this.form.zipcode && !validateZipcode(this.form.zipcode)) {
        this.formErrors.zipcode.push("This field must be a valid zipcode");
        withoutErrors = false;
      }
      if (this.form.hasPMPAccess) {
        this.formErrors.pmpRoles = [];
        if (!this.form.pmpRole) {
          this.formErrors.pmpRoles.push("Please select a PMP role");
          withoutErrors = false;
        }
      }
      this.formErrors.npi = [];
      if (!validateRequired(this.form.npi)) {
        this.formErrors.npi.push("This field is required");
        withoutErrors = false;
      } else if (!validateIsNumber(this.form.npi)) {
        this.formErrors.npi.push("This field must be a number");
        withoutErrors = false;
      } else if (!validateLengthEqualThan(this.form.npi.toString(), 10)) {
        this.formErrors.npi.push("This field must have 10 digits");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    clearErrors() {
      this.formErrors.user = [];
      this.formErrors.taxId = [];
      this.formErrors.npi = [];
      this.formErrors.pmpRoles = [];
      this.formErrors.zipcode = [];
      this.formErrors.accessToLocations = [];
      this.formErrors.manager = [];
    },
    async fetchUsers() {
      const users = await userServer.getFilteredUsers();
      this.users = users.map(user => ({
        value: user.id,
        label: this.formatUser(user),
        data: { ...user, fullName: this.formatUser(user) }
      }));
      this.usersFilters = this.users.filter(user => !user.data.providerInfo);
      this.usersFilters.sort((a, b) => {
        if (a.data.fullName < b.data.fullName.toLowerCase()) {
          return -1;
        }
        if (a.data.fullName > b.data.fullName.toLowerCase()) {
          return 1;
        }
        return 0;
      });
    },
    async fetchSupervisor(filter, data) {
      const supervisorOptions = await supervisionServer.getSupervisionChartUsers(
        filter,
        data
      );
      this.supervisorOptions = supervisorOptions.map(supervisor => ({
        value: supervisor.id,
        label: this.formatUser(supervisor),
        data: { ...supervisor, fullName: this.formatUser(supervisor) }
      }));
      this.supervisorOptions.sort((a, b) => {
        if (a.data.fullName < b.data.fullName.toLowerCase()) {
          return -1;
        }
        if (a.data.fullName > b.data.fullName.toLowerCase()) {
          return 1;
        }
        return 0;
      });
      if (this.organization != null) {
        this.supervisorOptions.push(this.organization);
      }
      this.supervisor = this.user.data.supervisorUserId
        ? this.supervisorOptions.find(
            supervisor => supervisor.value == this.user.data.supervisorUserId
          )
        : this.user.data.isInSupervisionChart
        ? this.organization
        : null;
    },
    fetchManagers() {
      this.managersOptions = this.users;
      if (this.providerId) {
        this.managersFiltersOptions = this.managersOptions.filter(
          u => u.value != this.providerId
        );
      } else {
        this.managersFiltersOptions = this.managersOptions;
      }
      this.manager = this.user?.data.manager
        ? this.managersFiltersOptions.find(
            manager => manager.value == this.user.data.manager.id
          )
        : null;
    }
  },
  computed: {
    ...mapState("layout", {
      credentials: state =>
        state.credentials.map(credential => ({
          value: credential.id,
          text: credential.name
        }))
    }),
    ...mapState("client", {
      states: state =>
        state.states.map(s => ({
          label: s.name,
          value: s.id
        })),
      locations: state =>
        state.locations.map(l => ({
          text: l.name,
          value: l.id
        })),
      placesOfServiceOptions: state =>
        state.placesOfService.map(placeOfService => ({
          value: placeOfService.id,
          label: `${placeOfService.code}-${placeOfService.name}`,
          data: placeOfService
        }))
    }),

    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  watch: {
    user: {
      async handler(val) {
        if (val) {
          let accessToLocations;
          if (!val.data.accessToLocations) {
            accessToLocations = await userServer.findAccessToLocations(
              val.value
            );
          } else {
            accessToLocations = val.data.accessToLocations;
          }
          this.form.accessToLocations = accessToLocations?.map(l => l.id);
          this.form.practiceSuitePhysician =
            val.data.practiceSuitePhysician ?? "";
          this.form.doseSpotId = val.data.doseSpotId ?? "";
          this.hasAccessToLocations();
          this.managersFiltersOptions = this.managersOptions.filter(
            u => u.value != val.value
          );
          await this.fetchSupervisor(
            { filter: "changeSupervisor", userId: val.value },
            { "Hide-Loading": true }
          );
        } else {
          this.managersFiltersOptions = this.managersOptions;
          this.form.accessToLocations = [];
          this.hasAccessToLocations();
        }
      },
      deep: true
    },
    manager: {
      handler(val) {
        if (val) {
          this.usersFilters = this.usersFilters.filter(
            u => u.value != val.value
          );
        } else {
          this.usersFilters = this.users.filter(
            user => !user.data.providerInfo
          );
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.modal >>> .modal-dialog {
  background-color: rebeccapurple;
}

.modal-dialog::v-deep {
  max-width: 1280px !important;
}
.section-body {
  min-height: 70px;
}

.add-button {
  max-height: 35px;
  margin: 30px 10px;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
